module.exports = __webpack_public_path__ + "static/img/show-left.0d11f809.png";